module.exports = "https://cdn.realtymogul.com/static/media/HP_card_wedgwood.8dd8f339.jpg";